module.exports = __webpack_public_path__ + "img/front_hall.ebd29ba0.png";